import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { paths } from 'src/routes/paths';

//Modificar de acuerdo a la lógica de la acción
export const comprarInsumo = createAsyncThunk(
  'insumoForm/comprarInsumo',
  async (
    { data, navigate }: { data: any; navigate: any },
    { rejectWithValue }
  ) => {
    try {
      navigate(paths.dashboard.compras.compras, {
        state: { data, openModalFromInsumo: true },
      });
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(error.response?.data || 'Error al navegar');
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const verificarInsumoF = createAsyncThunk(
  'insumoForm/verificarInsumoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.verificarInsumoF,
        data
      );
      handleOKRequest(response, 'Insumo verificado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al verificar el insumo.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const discontinuarInsumoF = createAsyncThunk(
  'insumoForm/discontinuarInsumoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.discontinuarInsumoF,
        data
      );
      handleOKRequest(response, 'Insumo discontinuado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al discontinuar el insumo.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const actualizarInsumoPrecio = createAsyncThunk(
  'insumoForm/actualizarInsumoPrecio',
  async (
    { data, formRef }: { data: any; formRef: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        endpoints.actions.actualizarInsumoPrecio,
        data
      );
      formRef.current.instance.updateData({
        ultimaActualizacion: response.data.ultimaActualizacion,
        ultimaCompra: response.data.ultimaCompra,
        precioUnitarioUnificado: response.data.precioUnitarioUnificado,
        actualizadoAMano: false,
      });
      handleOKRequest(response, 'Precio del insumo actualizado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al actualizar el precio del insumo.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const estimarInsumoPrecioF = createAsyncThunk(
  'insumoForm/estimarInsumoPrecioF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.estimarInsumoPrecioF,
        data
      );
      handleOKRequest(response, 'Precio del insumo estimado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al estimar el precio del insumo.'
      );
    }
  }
);
